import React from 'react';

import { cn } from '@lyearn/style';
import { Image } from '@/components/Image';

import { useProviderContent } from '../context';
import { IconProps } from '../types';

function Icon({ className = 'w-40 h-40', width = 40, height = 40 }: IconProps) {
  const { provider } = useProviderContent();

  if (!provider?.logo.url) {
    return null;
  }

  return (
    <Image
      alt={provider.name}
      className={cn('rounded-4', className)}
      height={height}
      src={provider.logo.url}
      width={width}
    />
  );
}

export default React.memo(Icon);
